import { useState } from "react";
import { useTranslation } from "react-i18next";

import { AddressForm } from "../../../components/AddressForm";
import { SettingsEditItem } from "../../../components/Settings/SettingsEditItem";
import { useFormSubmit } from "../../../hooks/api/useSubmit";
import { useUser } from "../../../hooks/api/useUser";

export function AddressSettings() {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const toggle = () => setExpanded((curr) => !curr);
  const { user, mutate } = useUser();
  const homeAddress = user?.personal_profile?.profile_addresses[0]?.address;

  const handleSubmit = useFormSubmit("/internal/people/me/address/update/", {
    onSuccess: () => {
      toggle();
      mutate();
    },
  });

  return (
    <SettingsEditItem
      setting={t("Home address")}
      value={homeAddress ? homeAddress : t("Not provided")}
      description={t("Use your current home address")}
      expanded={expanded}
      toggle={toggle}
      testID={expanded ? "home-address-cancel-link" : "home-address-edit-link"}
    >
      <AddressForm
        handleSubmit={handleSubmit}
        userInformation={user}
        testID="settings-address-form"
      />
    </SettingsEditItem>
  );
}
